// Identifiers for the modals rendered by components/common/ModalRoot.
//
// These live in their own module (rather than alongside ModalRoot) so that
// components which only need to *open* a modal do not import ModalRoot itself.
// ModalRoot imports every modal component, and some of those (via the
// Permission HOC) need these identifiers back — importing them from ModalRoot
// created an ESM import cycle that the production (scope-hoisted) bundle
// evaluated in the wrong order, crashing on load with
// "Cannot access 'f' before initialization" (JR-1303).
export const MODAL_COMPONENTS = {
    SAVE_USER_MODAL: 'SAVE_USER_MODAL',
    CREATE_DISTRIBUTOR_MODAL: 'CREATE_DISTRIBUTOR_MODAL',
    CREATE_ENTITY_MODAL: 'CREATE_ENTITY_MODAL',
    ASSIGN_TICKET_MODAL: 'ASSIGN_TICKET_MODAL',
    SAVE_RELATIONSHIP_MODAL: 'SAVE_RELATIONSHIP_MODAL',
    SAVE_ENTITY_MODAL: 'SAVE_ENTITY_MODAL',
    SAVE_USERGROUP_MODAL: 'SAVE_USERGROUP_MODAL',
    CREATE_PARTY_MODAL: 'CREATE_PARTY_MODAL',
    ADD_USER_TO_USERGROUP_MODAL: 'ADD_USER_TO_USERGROUP_MODAL',
    REMOVE_USER_FROM_USERGROUP: 'REMOVE_USER_FROM_USERGROUP',
    SAVE_PARTY_ADDRESS_MODAL: 'SAVE_PARTY_ADDRESS_MODAL',
    CREATE_PERMISSION_MODAL: 'CREATE_PERMISSION_MODAL',
    ADD_FILTER_MODAL: 'ADD_FILTER_MODAL',
    PERMISSION_ADD_USER_MODAL: 'PERMISSION_ADD_USER_MODAL',
    QUESTION_SET_MODAL: 'QUESTION_SET_MODAL',
    LAUNCH_EXECUTION_PLAN_MODAL: 'LAUNCH_EXECUTION_PLAN_MODAL',
    SAVE_CREATE_THRESHOLD_MODAL: 'SAVE_CREATE_THRESHOLD_MODAL',
    SAVE_ADMIN_THRESHOLD_MODAL: 'SAVE_THRESHOLD_ADMIN_MODAL',
    ADD_EXISTING_ATTACHMENT: 'ADD_EXISTING_ATTACHMENT',
    MANAGE_PERMISSIONS_MODAL: 'MANAGE_PERMISSIONS_MODAL',
    EDIT_ATTACHMENT_DETAILS: 'EDIT_ATTACHMENT_DETAILS',
    CREATE_ACTIVITY_MODAL: 'CREATE_ACTIVITY_MODAL',
    BULK_IMPORT_ENTITY_MODAL: 'BULK_IMPORT_ENTITY_MODAL',
    BULK_REMIND_DISTRIBUTORS_MODAL: 'BULK_REMIND_DISTRIBUTORS_MODAL',
    ASSIGN_DELEGATE: 'ASSIGN_DELEGATE',
    LAUNCH_GOVERNANCE_PROGRAMME_MODAL: 'LAUNCH_GOVERNANCE_PROGRAMME_MODAL',
    TERMS_AND_CONDITIONS_MODAL: 'TERMS_AND_CONDITIONS_MODAL',
    CREATE_ACTION_MODAL: 'CREATE_ACTION_MODAL',
    SAVE_LOOK_UP_TYPE_MODAL: 'SAVE_LOOK_UP_TYPE_MODAL',
    SAVE_LOOK_UP_VALUE_MODAL: 'SAVE_LOOK_UP_VALUE_MODAL',
    SAVE_RATING_TYPE_MODAL: 'SAVE_RATING_TYPE_MODAL',
    SAVE_RATING_VALUE_MODAL: 'SAVE_RATING_VALUE_MODAL',
    SAVE_API_KEY_MODAL: 'SAVE_API_KEY_MODAL',
    ADD_PRODUCTS_MODAL: 'ADD_PRODUCTS_MODAL',
    ADD_COVERHOLDER_AND_COMANUFACTURER: 'ADD_COVERHOLDER_AND_COMANUFACTURER',
};
